export default __webpack_public_path__ + "static/media/apple-icon-76x76.a09e8dee.png";